import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { AuthService } from "../authorization/auth.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(public authService: AuthService, public router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isLoggedIn !== true) {
      if (this.router.routerState.snapshot.url === "legal/privacy-policy") {
        this.router.navigate(["legal/privacy-policy"]);
      } else {
        this.router.navigate(["/login"]);
      }
    }
    return true;
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isLoggedIn !== true) {
      if (this.router.routerState.snapshot.url === "legal/privacy-policy") {
        this.router.navigate(["legal/privacy-policy"]);
      } else {
        this.router.navigate(["/login"]);
      }
    }
    return true;
  }
}
